import * as React from 'react';
import { cn } from '@/lib/utils';

const SwiperWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-swiper-wrapper',
      'mb-6',
      '[&_.swiper]:pb-8',
      '[&_.swiper-pagination]:!bottom-0',
      '[&_.swiper-pagination-bullet]:!mx-3 [&_.swiper-pagination-bullet]:!my-0 [&_.swiper-pagination-bullet]:bg-primary-light',
      '[&_.swiper-pagination-bullet-active]:bg-primary-light',
      '[&_.swiper-slide]:px-4 [&_.swiper-slide]:py-2',
      '[&_.swiper-button-next]:right-0 [&_.swiper-button-next]:h-10 [&_.swiper-button-next]:w-10 [&_.swiper-button-next]:-translate-y-1/2 [&_.swiper-button-next]:rounded-full [&_.swiper-button-next]:border [&_.swiper-button-next]:border-solid [&_.swiper-button-next]:border-primary-lightest [&_.swiper-button-next]:bg-white [&_.swiper-button-next]:text-primary [&_.swiper-button-next]:shadow-dropshadow-sm',
      '[&_.swiper-button-prev]:left-0 [&_.swiper-button-prev]:h-10 [&_.swiper-button-prev]:w-10 [&_.swiper-button-prev]:-translate-y-1/2 [&_.swiper-button-prev]:rounded-full [&_.swiper-button-prev]:border [&_.swiper-button-prev]:border-solid [&_.swiper-button-prev]:border-primary-lightest [&_.swiper-button-prev]:bg-white [&_.swiper-button-prev]:text-primary [&_.swiper-button-prev]:shadow-dropshadow-sm',
      '[&_.swiper-button-next::after]:text-base',
      '[&_.swiper-button-prev::after]:text-base',
      '[&_.swiper-button-disabled]:hidden',
      '[&_.c-warning-wall]:mb-0',
      className
    )}
    {...props}
  />
));
SwiperWrapper.displayName = 'SwiperWrapper';

export { SwiperWrapper };
